import { useNetworkConnection } from '@/hooks/useNetworkConnection';
import { useAppVersion } from '@/hooks/useAppVersion';

interface GlobalModalsState {
  hasGlobalModalVisible: boolean;
  isNetworkModalVisible: boolean;
  isForceUpdateModalVisible: boolean;
  isRecommendedUpdateModalVisible: boolean;
}

export function useGlobalModalsState(): GlobalModalsState {
  const { hasInternetConnection } = useNetworkConnection();
  const { forceUpdateRequired, recommendedUpdateAvailable } = useAppVersion();

  const isNetworkModalVisible = !hasInternetConnection;
  const isForceUpdateModalVisible = forceUpdateRequired;
  const isRecommendedUpdateModalVisible = recommendedUpdateAvailable && !forceUpdateRequired;

  const hasGlobalModalVisible =
    isNetworkModalVisible ||
    isForceUpdateModalVisible ||
    isRecommendedUpdateModalVisible;

  return {
    hasGlobalModalVisible,
    isNetworkModalVisible,
    isForceUpdateModalVisible,
    isRecommendedUpdateModalVisible,
  };
}

